import React from 'react';
import {Yandex} from "../yandex-ads";

export default function DeliveryUnloadingGroupList({groupName, items}) {

    return (
        <div className="application-block">
            <Yandex renderTo="rtb-1" />
           {/*  <h1 className="group-name">{groupName}</h1> */}
            {items}
        </div>
    );
}

